// Download service using direct Cloudinary URLs (SDK doesn't work in browser due to CORS)
export const downloadFile = async (url, filename = 'document.pdf') => {
  try {
    console.log('🔍 Download attempt:', { url, filename });
    
    if (url && url.includes('cloudinary.com')) {
      console.log('🌩 Cloudinary URL detected:', { original: url });
      
      // Try different URL formats to find the working one
      const urlVariations = [
        url, // Original URL
        url.replace('/raw/upload/', '/raw/upload/fl_attachment/'), // Force attachment
        url.replace('/raw/upload/', '/raw/upload/fl_attachment,q_auto/'), // Force attachment + quality
        url + '?fl=attachment', // Add attachment param
        url.replace('/raw/upload/', '/image/upload/fl_attachment/'), // Try as image with attachment
        url.split('?')[0], // Remove query params
      ];
      
      for (let i = 0; i < urlVariations.length; i++) {
        const testUrl = urlVariations[i];
        console.log(`📥 Trying URL variation ${i + 1}:`, testUrl);
        
        try {
          const response = await fetch(testUrl, {
            method: 'GET',
            headers: {
              'Accept': 'application/pdf,application/octet-stream',
              'Cache-Control': 'no-cache'
            }
          });
          
          console.log(`📊 Response ${i + 1}:`, response.status, response.statusText);
          
          if (response.ok) {
            const blob = await response.blob();
            console.log('✅ Blob created, size:', blob.size, 'bytes');
            
            const blobUrl = window.URL.createObjectURL(blob);
            
            // Create download link
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = filename;
            link.style.display = 'none';
            
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            // Clean up blob URL
            setTimeout(() => window.URL.revokeObjectURL(blobUrl), 100);
            
            return { success: true, workingUrl: testUrl };
          }
        } catch (err) {
          console.log(`❌ Variation ${i + 1} failed:`, err.message);
          continue;
        }
      }
      
      throw new Error('All URL variations failed');
    } else {
      // Non-Cloudinary URL - use direct download
      console.log('📥 Non-Cloudinary URL - using direct download');
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/pdf,application/octet-stream'
        }
      });
      
      if (response.ok) {
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = filename;
        link.style.display = 'none';
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        setTimeout(() => window.URL.revokeObjectURL(blobUrl), 100);
        
        return { success: true };
      } else {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
    }
  } catch (error) {
    console.error('💥 Download error:', error);
    
    // Fallback: try opening original URL in new tab
    try {
      console.log('🔄 Trying fallback: open in new tab');
      window.open(url, '_blank');
      return { success: false, fallback: 'opened_in_tab' };
    } catch (fallbackError) {
      console.error('💥 Fallback failed:', fallbackError);
      return { success: false, error: error.message };
    }
  }
};

export const getDownloadFilename = (paper) => {
  const { title, year, subject } = paper;
  const cleanTitle = title ? title.replace(/[^a-z0-9]/gi, '_').toLowerCase() : 'paper';
  return `${year || ''}_${subject || ''}_${cleanTitle}.pdf`;
};
